import { useEffect, useState } from 'react';
import { transformValue } from './helpers/transformValue';
export const useTransformVisualValue = (initialValue, transformers) => {
    const [rawValue, setRawValue] = useState(initialValue);
    const [formattedValue, setFormattedValue] = useState(transformValue(initialValue, transformers));
    useEffect(() => {
        setFormattedValue(transformValue(rawValue, transformers));
    }, [rawValue, transformers]);
    const handleChange = (event) => {
        const newValue = event.target.value;
        setRawValue(newValue);
        setFormattedValue(transformValue(newValue, transformers));
    };
    return [rawValue, formattedValue, handleChange];
};
